export default __webpack_public_path__ + "static/media/Pallavi.7da38695.jpeg";